export const permissionToBool = (permString: string) => {
  const perm = parseInt(permString, 10);
  return perm === 1 ? true : false;
};
